module.exports = __webpack_public_path__ + "img/img-Brasil.f9c57a1b.jpeg";